var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "greentool__container" },
    [
      _vm.filters && _vm.filters.length
        ? [
            _c(
              "div",
              { staticClass: "greentool__filter" },
              [
                _c("div", { staticClass: "greentool__filterlabel" }, [
                  _vm._v(_vm._s(_vm.$t("greentool.filterlabel"))),
                ]),
                _vm._v(" "),
                _c("sal-filter-group", { attrs: { filters: _vm.filters } }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedFilters && Object.keys(_vm.selectedFilters).length
        ? [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [_c("sal-filter-selected")],
                1
              ),
            ]),
            _vm._v(" "),
            _c("sal-results", { staticClass: "row" }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }